














































































// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator'
import EditBaseGroupCarac from '@/components/groupCarac/edit/EditBaseGroupCarac.vue'
import { AloGroupCarac, getDefaultAloGroupCarac } from '@/models/alo/AloGroupCarac'
import * as rules from '@/utils/validationRules'
import { toSubArray, toNumberDictionary } from '@/utils/groupBy'
import { AloBase } from '@/models/alo/AloBase'
import { AloCarac } from '@/models/alo/AloCarac'
import apiCarac from '@/api/carac'
import { directPayloadQuery } from '@/utils/api'
import draggable from 'vuedraggable'

@Component({ 
  name: 'EditMarques',    
  components:{EditBaseGroupCarac,draggable}
})
export default class EditMarques extends Vue {
  
  groupCarac = getDefaultAloGroupCarac()  

  drag = false
  loadingCarac = false
  search:string = ""
  uni:number=-1
  rub:number=-1
  fam:number=-1

  searchCarac = [] as Array<AloCarac>
    

  get universList(){
    return [{id:-1,libelle:"Tous les univers"},
              ...this.$store.myGetters.universList
                                      .sort((i1,i2)=> i1.libelle.localeCompare(i2.libelle))
          ]
  }

  get rubriques(){
    return this.$store.myGetters.rubriques
  }

  get rubriquesList(){
    return [{id:-1,libelle:"Toutes les rubriques"},
            ...this.$store.myGetters.rubriquesList.filter(r => this.uni == -1 || r.uniId == this.uni)
                                                  .sort((i1,i2)=> i1.libelle.localeCompare(i2.libelle))
          ]
  }

  get familles(){
    return this.$store.myGetters.familles
  }

  get famillesList(){
    return [{id:-1,libelle:"Toutes les familles"},
            ...this.$store.myGetters.famillesList.filter(r => (this.uni == -1 || r.uniId == this.uni) && (this.rub == -1 || r.rubId == this.rub))
                                                  .sort((i1,i2)=> i1.libelle.localeCompare(i2.libelle))
          ]
  }

  get filteredCaracteristiques(){
    return this.searchCarac.filter(c => 
      (!this.search || this.search.length == 0 || this.removeDiacritics(c.cavNom.toLocaleLowerCase()).indexOf(this.removeDiacritics(this.search.toLocaleLowerCase())) > -1)
    )
  }

  removeDiacritics = (str:string) => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  get selectedCaracteristiques() {
    return this.groupCarac.grcParamJson.caracIdxcs.map(id => this.$store.myGetters.carac[id]).filter(c => !!c)
  }

  addCarac(c:AloCarac) {
    const index = this.groupCarac.grcParamJson.caracIdxcs.indexOf(c.cavIdxc);
    if (index == -1) { // add only if not présent 
      this.groupCarac.grcParamJson.caracIdxcs.push(c.cavIdxc)
    }    
  }

  removeCarac(c:AloCarac) {
    const index = this.groupCarac.grcParamJson.caracIdxcs.indexOf(c.cavIdxc);
    if (index > -1) { // only splice array when item is found
      this.groupCarac.grcParamJson.caracIdxcs.splice(index, 1); // 2nd parameter means remove one item only
    }
  }
    
  private tableauHeight = 400



  @Watch("uni")
  onUniChanged() {    
    this.fam = -1
    this.rub = -1    
    this.findCarac()     
  }

  @Watch("rub")
  onRubChanged() {    
    this.fam = -1    
    this.findCarac()     
  }
  
  @Watch("fam")
  onFamChanged() {    
   this.findCarac()     
  }

  onResize() {                  
    //@ts-ignore    
    this.tableauHeight = this.$refs.baseEdit.$el.clientHeight - 320
  }


  edit(item:AloGroupCarac) {    
    this.onResize()            
    this.search = ""    
    this.fam = -1
    this.rub = -1
    this.uni = -1        
    this.searchCarac = this.$store.myGetters.caracList    

    this.groupCarac =  (this.$refs.baseEdit as EditBaseGroupCarac).edit(item)              
  }  
  
  

  async findCarac() {
    if(!this.loadingCarac) {
      this.loadingCarac = true
      if(this.uni == -1 && this.rub == -1 && this.fam == -1) {
        this.searchCarac = this.$store.myGetters.caracList
      }
      else{
        this.searchCarac = await directPayloadQuery(apiCarac.getCarac,{u:this.uni,r:this.rub,f:this.fam},this.$store)    
      }    
      this.loadingCarac = false
    }
  }
    
}
